import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TableSort from '../tableComponents/TableSort'
import Help from '../Help'
import { variableName } from "../js/constants"
import { hasMissing } from "../js/utilityRoutines"

const wdir_help = "CLM = calm winds; VRB = variable wind direction."
const windex_help = "A dash (-) indicates the conditions were not met for index calculation."

export default function MonhrlyTable(props) { 
  const { tabledata, hours_to_use, userParams, stnName } = props;
  const [ heads, setHeads ] = useState();
  const [ columnOrder, setColumnOrder ] = useState();
  const [ viewCodeHelp, setViewCodeHelp ] = useState(false);
  const titleText = "Hourly " + variableName[userParams.variable].name + " (" + variableName[userParams.variable].units + ') for ' + userParams.fromDate.format('MMMM YYYY') +
    "<br />"+stnName;
  const footerText = hasMissing(tabledata) + 
      (userParams.variable === "wdir" ? "<br />" + wdir_help : "") + 
      (userParams.variable === "wchill" || userParams.variable === "htindx" ? "<br />" + windex_help : "");
  const noSmryVars = ['wdir','wx','clds','wgust'];

  useEffect(() => {
    const headrow1 = []
    headrow1.push({
      text: "Day", 
      rowSpan: "2",
      component: "th",
      id: "day",
      initSort: true,
      sortOrder: 'asc'
    })
    headrow1.push({
      text: "Hour" + (userParams.variable === 'pcpn' ? " Ending " : " ") + "(LST)", 
      colSpan: "" + hours_to_use.length,
      id: null
    })
    if (!noSmryVars.includes(userParams.variable)) {
      headrow1.push({
        text: ['pcpn','srad'].includes(userParams.variable) ? "Sum" : "Mean", 
        rowSpan: "2",
        id: "smry"
      })
    }
    const headrow2 = []
    hours_to_use.map((hr) => {
      headrow2.push({
        text: hr,
        id: hr
      })
    })

    const columnOrder = []
    columnOrder.push({
      component: "th",
      id: "day",
    })
    hours_to_use.map((hr) => {
      columnOrder.push({
        id: hr
      })
    })

    if (!noSmryVars.includes(userParams.variable)) {
      columnOrder.push({
        id: "smry"
      })
    }

    setHeads([headrow1, headrow2])
    setColumnOrder(columnOrder)
  }, [])

  return (
    <>
      <Box sx={{my: 1}}>
        {heads && columnOrder &&
          <TableSort
            titleText={titleText} 
            heads={heads}  
            columnOrder={columnOrder}
            tabledata={tabledata} 
            footerText={footerText}
          />
        }
      </Box>

      {userParams.variable === 'wx' &&
        <>
          <Button 
            variant="outlined" 
            size="small"   
            sx={{ mb: 1 }}
            onClick={() => { setViewCodeHelp(!viewCodeHelp) }}
          >
            {viewCodeHelp ? "Hide" : "View"} present weather code definitions
          </Button>
          {viewCodeHelp &&
            <Help variable="wx" />
          }
        </>
      }
      {userParams.variable === 'clds' &&
        <>
        <Button 
          variant="outlined" 
          size="small" 
          sx={{ mb: 1 }}
          onClick={() => { setViewCodeHelp(!viewCodeHelp) }}
        >
          {viewCodeHelp ? "Hide" : "View"} cloud conditions code definitions
        </Button>
        {viewCodeHelp &&
          <Help variable="clds" />
        }
        </>
      }
    </>
  )
}
